import { Timestamp } from "firebase/firestore";
import { toISODate } from "../../utils/date";

/**
 * Converter uma string YYYY-MM-DD ou Date() para um Timestamp de Meia-Noite
 * Muito útil para garantir que ao puxar as sessões do dia 17, todas tenham o mesmo timestamp 00:00
 */
const normalizeToMidnightTimestamp = (dateInput) => {
    if (!dateInput) return Timestamp.now();
    let d = new Date(dateInput);
    if (isNaN(d.getTime())) d = new Date();
    // Forçar meia-noite
    d.setHours(0, 0, 0, 0);
    return Timestamp.fromDate(d);
};

export const sessionToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    // String Date para query hiper-rápida. Ex: "2026-03-17" 
    // É mais barato em NoSQL dar query exata `where("dateString", "==", "2026-03-17")` 
    // do que dois wheres `<= / >=` de Timestamp (Ocupa chaves de índice e piora performance).
    let dateStr = "";
    if (data.date instanceof Date) {
        dateStr = toISODate(data.date);
    } else if (typeof data.date === "string" && data.date.includes("T")) {
        dateStr = data.date.split("T")[0];
    } else {
        dateStr = data.date; // already YYYY-MM-DD?
    }

    const payload = {
        idTenant,
        idClass: data.idClass,
        idActivity: data.idActivity,
        activityName: data.activityName,
        activityColor: data.activityColor,
        evaluationSystem: !!data.evaluationSystem,
        
        // Dados do Dia
        idEmployee: data.idEmployee,
        employeeName: data.employeeName,
        employeePhone: data.employeePhone,
        employeeEmail: data.employeeEmail,
        employeePhotoUrl: data.employeePhotoUrl,
        
        idArea: data.idArea,
        areaName: data.areaName,
        
        // Otimização de Arquitetura:
        dateString: dateStr, // EX: 2026-03-17 (Query Exata === Fast!)
        dateTimestamp: normalizeToMidnightTimestamp(data.date), // Opcional pra Range (01 a 31 de Março)
        
        startTime: data.startTime,
        endTime: data.endTime,
        maxCapacity: Number(data.maxCapacity),

        status: data.status,

        // Contadores
        attendanceCompleted: !!data.attendanceCompleted,
        enrolledCount: Number(data.enrolledCount),
        experimentalCount: Number(data.experimentalCount),
        presentCount: Number(data.presentCount),
        absentCount: Number(data.absentCount),

        // Lista de Presenças
        attendances: Array.isArray(data.attendances) ? data.attendances.map(a => ({
            idMember: a.idMember,
            memberName: a.memberName,
            memberPhone: a.memberPhone,
            memberEmail: a.memberEmail,
            memberPhotoUrl: a.memberPhotoUrl,
            type: a.type, // REGULAR, REPLACEMENT, TRIAL
            status: a.status, // BOOKED (agendado), PRESENT, ABSENT, JUSTIFIED
            timestamp: a.timestamp instanceof Date ? Timestamp.fromDate(a.timestamp) : (a.timestamp || Timestamp.now())
        })) : [],

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? (data.createdBy || null) : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

export const sessionFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        
        // Monta o date de volta pro UI caso eles esperem algo preenchido no DatePicker
        date: data.dateString,

        // Converte os timestamps da sub-lista caso queira debugar 
        attendances: (data.attendances || []).map(a => ({
            ...a,
            timestamp: a.timestamp?.toDate ? a.timestamp.toDate() : a.timestamp
        })),

        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
